import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import {  Loading } from "components/assets/Icons";

import PageHeader from "components/PageHeader";
import styles from './EditTruck.module.scss'
import GeneralInfo from "./Components/GeneralInfo/GeneralInfo";
import DriverInfo from "./Components/DriverInfo";
import TruckInfo from "./Components/TruckInfo";
import PopUpSuccess from "./Components/PopUpSuccess";
import trucksService from "services/trucks.service";
import {isEmptyDriver, isEmpty, transformEmptyOrUndefinedToNull} from './Components/helpers'

const EditTruck = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const item = location.state?.item;

  const [loading, setLoading] = useState(false);
  const [currentScreen,] = useState({
    screen: "Edit truck",
    title: "Edit Truck",
  });
  const [success, setSuccess] = useState(false)

  const [fetchData, setFetchData] = useState({
    id: item.id,
    unit: item?.unit,
    associated_users_ids: item?.associated_users_names,
    dispatcher: {
      name: item?.dispatcher.name,
      phone_number: item?.dispatcher.phone_number
    },
    drivers: [{
      name: item?.drivers[0].name,
      phone_number: item?.drivers[0].phone_number,
      tsa_certificate: item?.drivers[0].tsa_certificate,
      twic_certificate: item?.drivers[0].twic_certificate,
      hazmat_certificate: item?.drivers[0].hazmat_certificate,
      can_cross_us_can_border: item?.drivers[0].can_cross_us_can_border,
      us_citizen: item?.drivers[0].us_citizen,
    },{
      name : item?.drivers[1]?.name ? item?.drivers[1]?.name : null,
      phone_number: item?.drivers[1]?.phone_number ? item?.drivers[1]?.phone_number : null
    } ],
    length: item?.dimensions.split("x")[0],
    width: item?.dimensions.split("x")[1],
    height: item?.dimensions.split("x")[2],
    payload: item?.payload,
    air_ride: item?.air_ride,
    lift_gate: item?.lift_gate,
    dock_high: item?.dock_high,
    pallet_jack: item?.pallet_jack,
    truck_note: item?.truck_note ? item?.truck_note : null
  })
  const prevFetchDataRef = useRef(fetchData);
  

  const updateData = (field, indexOrId, value) => {
    setFetchData(prev => {
        if (field === 'drivers') {
            return {
                ...prev,
                drivers: prev.drivers.map((driver, idx) =>
                    idx === indexOrId ? { ...driver, ...value } : driver
                )
            };
        }
        if (field === 'associated_users_ids') {
          return {
              ...prev,
              associated_users_ids: value
          };
        }
        
        if (field === 'dispatcher') {
          return {
              ...prev,
              dispatcher: {
                  ...prev.dispatcher,
                  ...value
              }
          };
      }
        return {
            ...prev,
            [field]: typeof value === 'object' ? {
                ...prev[field],
                ...value
            } : value
        };
    });
};


// validation
const [associatedUserErr, setAssociatedUserErr] = useState('')
const [unitError, setunitError] = useState("")
const [dispatcherNameErr, setDispatcherNameErr] = useState("")
const [dispatcherPhoneErr, setDispatcherPhoneErr] = useState("")
const generalErrors = {associatedUserErr,unitError,dispatcherNameErr,dispatcherPhoneErr}

const [driverNameErr, setDriverNameErr] = useState("")
const [driverPhoneErr, setDriverPhoneErr] = useState("")
const driverErrors = {driverNameErr,driverPhoneErr}

const [boxLErr, setBoxLErr] = useState("")
const [boxWErr, setBoxWErr] = useState("")
const [boxHErr, setBoxHErr] = useState("")
const [maxPErr, setMaxPErr] = useState("")
const [noteErr, setNoteErr] = useState("")
const truckrErrors = {boxLErr,boxWErr, boxHErr, maxPErr, noteErr}

useEffect(() => {
  const prevFetchData = prevFetchDataRef.current;

  if(prevFetchData.associated_users_ids !== fetchData.associated_users_ids) setAssociatedUserErr('')
  if(prevFetchData.dispatcher?.name !== fetchData.dispatcher?.name) setDispatcherNameErr("")
  if(prevFetchData.dispatcher?.phone_number !== fetchData.dispatcher?.phone_number) setDispatcherPhoneErr("")
  if(prevFetchData.unit !== fetchData.unit) setunitError("")
  if(prevFetchData.drivers?.[0]?.name !== fetchData.drivers?.[0]?.name) setDriverNameErr("")
  if(prevFetchData.drivers?.[0]?.phone_number !== fetchData.drivers?.[0]?.phone_number) setDriverPhoneErr("")
  if(prevFetchData.length !== fetchData.length)setBoxLErr("")
  if(prevFetchData.width !== fetchData.width)setBoxWErr("")
  if(prevFetchData.height !== fetchData.height)setBoxHErr("")
  if(prevFetchData.payload !== fetchData.payload)setMaxPErr("")
  if(prevFetchData.truck_note !== fetchData.truck_note)setNoteErr("")

  prevFetchDataRef.current = fetchData;

}, [fetchData])

  const validate = () => {
    let associatedUser, unitError, driverNameErr,driverPhoneErr,boxLErr, boxWErr,boxHErr,maxPErr, noteErr
    
    //associated user
    if(fetchData?.associated_users_ids?.length < 1) {
      associatedUser = "This field is required"
      setAssociatedUserErr(associatedUser)
    }
    //unit
    if(isEmpty(fetchData?.unit)) {
      unitError = "This field is required"
      setunitError(unitError)
    } 
    if (fetchData?.unit?.length > 30){
      unitError = "Max 30 symbols"
      setunitError(unitError)
    }
    //dispatcher Name temporary not required
    // if (!fetchData.dispatcher.name) {
    //   setDispatcherNameErr("This field is required")
      
    // } else if(fetchData.dispatcher.name.length > 255) {
    //   setDispatcherNameErr("Max 255 symbols")
    // }
    // //dispatcher number temporary not required
    // if(fetchData.dispatcher.phone_number <3) {
    //   setDispatcherPhoneErr("This field is required")
    // } else if(fetchData.dispatcher.phone_number.length <16){
    //   setDispatcherPhoneErr("Phone number should be 10 digits")
    // }
    //driver 1 name
    if (!fetchData.drivers[0].name) {
      driverNameErr = "This field is required"
      setDriverNameErr(driverNameErr)
    } 
    if(fetchData?.drivers[0].name?.length > 255) {
      driverNameErr = "Max 255 symbols"
      setDriverNameErr(driverNameErr)
    }
    // driver 1 phone
    if(!fetchData?.drivers[0]?.phone_number) {
      driverPhoneErr = "This field is required"
      setDriverPhoneErr(driverPhoneErr)
    }  
    if(fetchData?.drivers[0]?.phone_number?.length <16){
      driverPhoneErr = "Phone number should be 10 digits"
      setDriverPhoneErr(driverPhoneErr)
    }
    // Box length
    if (isEmpty(fetchData?.length)) {
      boxLErr = "This field is required"
      setBoxLErr(boxLErr)
    } 
    if((+fetchData?.length?.length > 3)) {
      boxLErr = "max 3 symbols (value 999)"
      setBoxLErr(boxLErr)
    }
    //box width
    if (isEmpty(fetchData?.width)) {
      boxWErr = "This field is required"
      setBoxWErr(boxWErr)
    } 
    if((fetchData?.width?.length > 3)) {
      boxWErr = "max 3 symbols (value 999)"
      setBoxWErr(boxWErr)
    }
    // box heigth
    if (isEmpty(fetchData?.height)) {
      boxHErr = "This field is required"
      setBoxHErr(boxHErr)
    } 
    if(fetchData?.height?.length > 3) {
      boxHErr = "max 3 symbols (value 999)"
      setBoxHErr(boxHErr)
    }
    // max payload
    if (isEmpty(fetchData?.payload)) {
      maxPErr = "This field is required"
      setMaxPErr(maxPErr)
    } 
    if(fetchData?.payload?.length > 5) {
      maxPErr = "max 5 symbols (value 999)"
      setMaxPErr(maxPErr)
    }
    //length
    if (fetchData?.truck_note?.length > 255) {
      noteErr = "Max 255 symbols"
      setNoteErr(noteErr)
    }
    let finalCheck = !associatedUser && !unitError && 
      !driverNameErr && !driverPhoneErr && !boxLErr && !boxWErr &&
        !boxHErr && !maxPErr && !noteErr
    return finalCheck
  };

  const handleSubmit = () => {
    if(fetchData) {
      if(!validate()) return
      let dataForReq = fetchData
      // Remove driver[1] if it is empty or null
      if (isEmptyDriver(dataForReq.drivers[1])) {
        dataForReq.drivers.splice(1, 1); // Removes 1 element at index 1
      }
      
      let prepared = transformEmptyOrUndefinedToNull(dataForReq)
      
      setLoading(true)
      trucksService.editTrucks(prepared).then((res) => {
        if (res.status === 200) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setSuccess("Truck edited")
          setLoading(false)
        }
      }).catch((e) => {
        console.error("Edit truck error:", e.response?.data)
        if(e.response?.data?.unit && e.response?.data?.unit[0]) setunitError(e.response?.data?.unit[0])
        setLoading(false)
        // TODO: validate errors
      })
    }
  };

  return (
    <>
      <div className="container">
        <PageHeader title={currentScreen.title} />
        
        <GeneralInfo fetchData={fetchData} updateData={updateData} errors={generalErrors}/>
        <DriverInfo fetchData={fetchData} updateData={updateData} errors={driverErrors}/>
        <TruckInfo fetchData={fetchData} updateData={updateData} errors={truckrErrors}/>
        
        <div  className={styles.buttongroup}>
          <Button
            size={VIEW.MIDDLE}
            color={COLOR.GREY}
            onClick={() => navigate(-1)}
          >
            Back to Trucks
          </Button>
          <Button size={VIEW.MIDDLE} onClick={handleSubmit}>
            {loading ? <Loading /> : "Edit Truck"}
          </Button>
        </div>
        {success && <PopUpSuccess text={success} />} 
      </div>
    </>
  );
};

export default EditTruck;
